export default {
  COMMITTED: 'COMMITTED',
  UNCOMMITTED: 'UNCOMMITTED'
};
